import { Link } from 'react-router';
import { AUFTRAGSTYPEN, TYP_REIHENFOLGE, type TypBeschreibung, typName } from '../auftragstypen.js';
import { LinienSymbol } from '../ui/linien-symbol.js';
import { Seitenkopf } from '../ui/seitenkopf.js';
import stile from './new-run-page.module.css';

/**
 * Typwahl aus dem Register: ein weiterer Typ erscheint hier, sobald er dort steht. Zwei Karten je
 * Zeile, Ratgeber und Ratgeber-Analyse oben nebeneinander (Reihenfolge in `TYP_REIHENFOLGE`).
 * Jede Karte nennt den Zeitbedarf, damit niemand einen Auftrag startet, ohne zu wissen, worauf
 * er sich einstellt (Rueckmeldung 2026-10-13).
 */
export function NewRunPage() {
  return (
    <>
      <Seitenkopf
        titel="Neuer Auftrag"
        pfad={[{ text: 'Übersicht', ziel: '/' }]}
        beschreibung="Wählen Sie, was entstehen soll. Im nächsten Schritt geben Sie das Briefing ein."
      />

      <div className={stile.raster}>
        {TYP_REIHENFOLGE.map((typ) => {
          const t: TypBeschreibung = AUFTRAGSTYPEN[typ];
          return (
            <section key={typ} className={stile.karte} aria-labelledby={`typ-${typ}`}>
              <div className={stile.kopf}>
                <span className={stile.symbol}>
                  <LinienSymbol name={t.symbol} groesse={24} />
                </span>
                <h2 id={`typ-${typ}`} className={stile.titel}>
                  {typName(typ)}
                </h2>
              </div>
              <p className={stile.erklaerung}>{t.erklaerung}</p>
              <div className={stile.fuss}>
                <p className={stile.dauer}>
                  <LinienSymbol name="clock" groesse={16} />
                  <span>{t.dauer}</span>
                </p>
                <Link className="eds-button eds-button--primary" to={`/neu/${typ}`}>
                  {t.text} starten
                </Link>
              </div>
            </section>
          );
        })}
      </div>
    </>
  );
}
